// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers } from '../configs/constants';

// requests
export async function main(origin?: any, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            site {
                copyright
                EsconderRodapeSobressai
                url_maps
                titulo_automatico
                modelo_pagina_imovel
                cards_busca
                mostrar_data_entrega
                afiliado_todo_site
                redes_topo
                categoria_home
                caracteristicas_home
                top_10
                depoimento_imovel
                ver_url
                banner_imovel
                cidade_priorizada
                cidade_busca
                mostrar_mapa
                texto_botao_whats
                formulario_whats
                exibir_empreendimento
                moeda_tipo
                simulador
                casa_em_condominio
                carousel_temporada
                carousel_apartamento
                carousel_lancamentos
                exibir_cidade_bairro_no_imovel
                carousel_casa
                carousel_novidades
                titulo_c_top
                titulo_c_temporada
                titulo_c_novidades
                titulo_c_casas
                titulo_c_1
                titulo_c_2
                titulo_c_c_condominio
                titulo_c_apartamentos
                id
                modelo_novo
                ordenar_lista
                mostrar_visualizacoes
                site
                titulo
                meta_keywords
                meta_description
                url_logo
                url_icon
                url_video
                rodape
                texto_rodape
                cor1
                cor2
                cor3
                cor4
                cor5
                cor6
                cor7
                congelado
                qtd_fotos_bloqueios
                bloquear_fotos
                pixel_facebook_head
                fb_pixel_teste
                link_chat_body
                link_chat_head
                tag_google_head
                tag_google_body
                libera_fts_aluguel
                banner_home
                carrossel_corretores
                frase_busca
                frase_busca_2
                tamanho_logo
                logo_horizontal
                navbar_transparente
                transacoes
                politica_privacidade
                termos_uso
                promocao
                Dados {
                    inicio_txt_descricao
                    horario
                    delegar_ao_agenciador
                    final_txt_descricao
                    empresa
                    email1
                    email2
                    email3
                    email4
                    tel1
                    tel2
                    tel3
                    tel4
                    tel1_nome
                    tel2_nome
                    tel3_nome
                    tel4_nome
                    tel1_whats
                    tel2_whats
                    tel3_whats
                    tel4_whats
                    endereco
                    cidade
                    bairro
                    creci
                    youtube
                    facebook
                    twitter
                    instagram
                    threads
                    tiktok
                    inicio_txt_descricao
                    final_txt_descricao
                }
                video
                widget_youtube
                widget_instagram
                marca_dagua {
                    ativada
                }
                exibir_agenciador
            }
            cidades {
                id
                nome
                id_estado
                url_foto
            }
            tipos {
                id
                nome
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function owners(origin?: any, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            banner_empresa {
                linkbanner
                card_titulo
                subtitulo_1
                paragrafo_1
                subtitulo_2
                paragrafo_2
                subtitulo_3
                paragrafo_3
                corconfig
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function managers(origin?: any, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            parceiros(mostrar_equipe: true) {
                id
                nome
                contador_atualizacao
                telefone
                telefone_2
                email
                mostrar_equipe
                descricao
                funcao {
                    id
                    nome
                }
                url_foto
                creci
                link_proprio
                linkedin
                instagram
                facebook
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function banners(origin?: any, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            banners {
                id
                codsite
                exibir
                url
                url_link
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}
